'use client';

import { DateOfBirth } from './Step02DateOfBirth';
import { Gender } from './Step03Gender';
import { Residence } from './Step04Residence';
import { PhoneNumber } from './Step05PhoneNumber';
import { Education } from './Step06Education';
import { GraduationStatus } from './Step07GraduationStatus';
import { EmploymentStatus } from './Step09EmploymentStatusStep';
import { JobChangedCount } from './Step10NoOfJobChanged';
import { CurrentCompany } from './Step11CurrentCompany';
import { JobIndustry } from './Step12JobIndustry';
import { JobOccupation } from './Step13JobOccupation';
import { AnnualSalary } from './Step14AnnualSalary';
import { DesiredJobOccupation } from './Step15DesiredJobOccupation';
import { DesiredJobLocation } from './Step16DesiredJobLocation';

export const RegistrationSteps = {
	AnnualSalary,
	CurrentCompany,
	DateOfBirth,
	DesiredJobLocation,
	DesiredJobOccupation,
	Education,
	EmploymentStatus,
	Gender,
	GraduationStatus,
	JobChangedCount,
	JobIndustry,
	JobOccupation,
	PhoneNumber,
	Residence,
};
